import $ from 'jquery';
import EFOcats_import_html from '../../../core/v2/import/efocats_import_html';
import EFOcats_import_lang from '../../../core/v2/import/efocats_import_lang';
import EFOcats_making from '../../../core/v2/making/efocats_making';

export default class EFOcats_iwatani_making extends EFOcats_making {
  /**
   * フレーム内のベースとなるHTMLを設置
   */
  base() {
    super.base();

    // 案件独自のファイルを読込み
    require('../scss/iwatani.scss');
    $(this.iframe).contents().find('head').append($('head').find('style').last());
  }

  /**
   * フレームの設置、調整
   * @returns 設定したフレーム
   */
  frame() {
    super.frame();

    // モーダルの閉じるボタンを設置
    $(this.frameElem).prepend(EFOcats_import_html.getValue('cat-modal-close'));

    // タイトル
    $('.cat-modal-close')
      .find('div')
      .last()
      .append(EFOcats_import_html.getValue('cat-page-header-text', {label: $('#product h2').text()}));

    // ローディング画像を消す
    this.loading(false);
  }

  /**
   * フレームに対するスタイルを設定、設置する
   */
  style() {
    super.style();
    this.settingModal();
  }

  /**
   * モーダルの設定
   */
  settingModal() {
    // モーダル設置
    $('#contents').append(EFOcats_import_html.getValue('cat-modal-src'));

    // スタイル
    require('../scss/iwatani_modal.scss');
    $('head').find('style').last().addClass('efocats_style');

    // オープンリンク設置
    $('a[href="#product"]').addClass('efocats_on');

    $('a[href="#product"]').each((index, element) => {
      const cl = $(element).clone(false);
      cl.removeAttr('href');
      cl.addClass('efocats_on_clone');
      $(element).hide();
      $(element).after(cl);
    });

    $('#contents').append(EFOcats_import_html.getValue('cat-modal-reshow-icon'));
    $('#contents').append(EFOcats_import_html.getValue('cat-modal-reshow'));
  }

  error() {
    super.error();

    // モーダル関連の要素を削除
    $('.efocats_reshow').remove();
    $('.cat-modal-bg').remove();
    $('.cat-modal').remove();

    $('.efocats_on_clone').remove();
    $('a[href="#product"]').show();
  }

  /**
   * loading画像表示/非表示
   * @param flg true=表示 false=非表示
   */
  loading(flg) {
    if (flg) {
      document.getElementById('container').appendChild(this.loadingdivElem);
    } else if (this.loadingdivElem.parentElement) {
      document.getElementById('container').removeChild(this.loadingdivElem);
    }
  }

  /**
   * go-flg付与、送信ボタン設置などの仕上げ処理
   */
  form_extend() {
    super.form_extend();
    $('#cat-dummy-layer').remove();
  }

  /**
   * 質問文を設置する
   * @param label_tmp
   * @param elem
   */
  question(label_tmp, elem) {
    let key = label_tmp.question;

    if (label_tmp.answer !== undefined) {
      key = label_tmp.answer[0].name;
    }

    if (this.titleList[key]) {
      const addTitle = $('<h1 />').addClass('qaTitle').text(this.titleList[key]);
      addTitle.insertBefore(elem.find('.cat-txt').eq(0));
    } else if (key === '支払方法説明') {
      if ($('[name="payment_type"] option').length === 1) {
        const text = $('[name="payment_type"] option').text();
        const addTitle = $('<h1 />').addClass('qaTitle').text(EFOcats_import_lang.getValue('支払い説明1', {text}));
        addTitle.insertBefore(elem.find('.cat-txt').eq(0));
      } else {
        const addTitle = $('<h1 />').addClass('qaTitle').text(EFOcats_import_lang.getValue('支払い説明2'));
        addTitle.insertBefore(elem.find('.cat-txt').eq(0));
      }
    }

    if (this.infoList[key]) {
      const addTitle = $('<p />').addClass('qaInfo').html(this.infoList[key]);
      addTitle.insertBefore(elem.find('.cat-txt').eq(0));
    } else if (key === '注文内容確認') {
      const addTitle = $('<p />').addClass('qaInfo').html($('form[name="form1"] tbody tr:first-child td div').html());
      addTitle.insertBefore(elem.find('.cat-txt').eq(0));
    } else if (key === '支払方法説明') {
      const note = document.querySelectorAll('form[name="form1"] tr')[11].querySelector('.notes').outerHTML;
      const addTitle = $('<p />').addClass('qaInfo').html(note);
      addTitle.insertBefore(elem.find('.cat-txt').eq(0));
    } else if (key === 'agree[]') {
      const addTitle = EFOcats_import_html.getValue('rule-section', {privacy: $('#agree .box').html(), url: $('#agree .column a ').attr('href')});
      $(addTitle).insertBefore(elem.find('.cat-txt').eq(0));
    }
  }

  /**
   * ページの拡張
   * @param label_tmp
   * @param elem
   * @param number
   */
  page_extend(label_tmp, elem, number) {
    super.page_extend(label_tmp, elem, number);

    // 設問欄ごとのラベル表示
    let key = label_tmp.question;

    if (label_tmp.answer !== undefined) {
      key = label_tmp.answer[0].name;
    }

    if (this.showlabelList.includes(key)) {
      if (Array.isArray(label_tmp.question)) {
        for (let index = 0; index < label_tmp.question.length; index++) {
          const textLabel = label_tmp.question[index];
          elem.find('.cat-txt').eq(index).html(textLabel);
        }
      } else {
        const textLabel = label_tmp.question;
        elem.find('.cat-txt').html(textLabel);
      }
    }

    if (label_tmp.answer !== undefined) {
      if (label_tmp.answer[0].name === 'year') {
        const nowyear = new Date().getFullYear();

        for (let index = 0; index < 120; index++) {
          elem.find('.year-select').append(EFOcats_import_html.getValue('select-question-option', {val: nowyear - index, text: nowyear - index}));

          if (nowyear - index === 1970) {
            elem.find('.year-select option').last().attr('selected', 'selected');
          }
        }

        elem.find('.year-select').parents('.selectBox').addClass('ok-flag').addClass('icon-flag');
        elem.find('.cat-txt').text('');
      } else if (label_tmp.answer[0].name === 'tel01') {
        elem.addClass('tel-section');
      } else if (label_tmp.answer[0].name === 'agree[]') {
        elem.addClass('rule-section');
      } else if (label_tmp.answer[0].name === 'chk01') {
        elem.find('[name="chk01"]').attr('value', '1');
      }
    }

    if (label_tmp.question === '支払方法説明') {
      elem.addClass('payment-section');
    }
  }

  /**
   * ラベルに対応したテンプレートを読み込み、ボタン等の共通パーツを設置する
   * @param tmp テンプレート名
   * @param number ラベルの番号
   * @returns テンプレート
   */
  template(tmp, number) {
    const tmpNames = ['set-adress', 'set-birthday'];

    if (tmpNames.includes(tmp)) {
      const tmphtml = require(`../html/${tmp}.html`);
      const elem = $(tmphtml);

      return elem;
    }
    return super.template(tmp, number);
  }

  /**
   * 回答欄設置クラスの使用条件設定
   */
  set_answers(tmp, answer, elem) {
    super.set_answers(tmp, answer, elem);

    // 任意
    if (!answer['data-required'] || answer['data-required'] !== '1') {
      this.answers.push('nini');
    }

    // 住所入力の時は他の処理を削除
    if (tmp[0] === 'set-adress') {
      this.answers = [];
      this.answers.push('set_adress');
    } else if (tmp[0] === 'set-birthday') {
      this.answers = [];
    }
  }
}
